import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-queueCarrier-lookup',
  templateUrl: './micro-queueCarrier-lookup.component.html'
})
export class MicroQueueCarrierLookupComponent  {

  @Input()
  queueCarrierId:any;
}
